import axios from "axios";
import { Flip, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from 'sweetalert2';
import { sidebarItems } from "../../component/Admin/SideBarItems";
export const actionTypes = {
  SET_LOGIN: "SET_LOGIN",
  SET_ROLE: "SET_ROLE",
  LOADER: "LOADER",
  FORGET_PASSWORD: "FORGET_PASSWORD",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  RESET_PASSWORD: "RESET_PASSWORD",
  GET_PAYMENT_DETAIL: "GET_PAYMENT_DETAIL"
};

export const LoginLoader = () => {
  return {
    type: actionTypes.LOADER,
    loader: true,
  };
};

// login
export const UserLogin = (contactno, password, login_type, type, history) => {
  const Data = {
    contactno: contactno,
    password: password,
    login_type: login_type,
    type: type,
  };
  
  return async (dispatch) => {
    await axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/admin/login`, Data, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        dispatch({
          type: actionTypes.SET_LOGIN,
          login: response?.data,
          loader: false,
        });

        dispatch({
          type: actionTypes.SET_ROLE,
          roleName: response?.data?.data?.role,
        });

        toast.success(response?.data?.message, {
          transition: Flip,
          theme: "colored",
          autoClose: 2000,
        });
        localStorage.setItem("Admin", JSON.stringify(response.data));
        if (response.data.data.role === "Admin") {
          history("/admin/admin_user/corporate");
        } else if (response.data.data.role === "Hr" || response.data.data.role === "Branch-Hr") {
          if (response.data.data.corporateName === 'Vibhuti') {
            history("/hr/employee");
          } else {
            history("/hr/uploademployee");
          }
        } else if (response.data.data.role === "Corporate" || response.data.data.role === "Corporate-branch") {
          history("/corporate/hr");
        } else if (response.data.data.role === "Doctor") {
          history("/doctor/employee-list")
        } else if (response.data.data.role === "Master-Corporate") {
          history("/master/branch")
        } else if (response.data.data.role === "Vfs-Master") {
          history("/vfs/branch")
        } else if (response.data.data.role === "Vfs-Branch") {
          history("/vfs-branch/member")
        }else if (response.data.data.role === "vsf_onevasco") {
          history("/onevasco/branch")
        }else if (response.data.data.role === "vfsuklk") {
          history("/vfs_uk_lp/branch")
        }else if (response.data.data.role === "accountant" || response.data.data.role === "sales" || response.data.data.role === "support") {
          history(`/vfs_uk_lp/${response.data.data.role}/memberlist`)
        }else if (response.data.data.role === "admanager" || response.data.data.role === "adsales"||  response.data.data.role ===  "adsupport" || response.data.data.role === "adaccountant") {
           const token = localStorage.getItem("Admin");
        const userData = JSON.parse(token);
        const permissions = userData?.data?.permission; 
        const findFirstAllowedPage = (items, allowedIds) => {
          for (const item of items) {
            if (item.subItems) {
              const subPage = findFirstAllowedPage(item.subItems, allowedIds);
              if (subPage) return subPage;
            } else if (!item.pageId || allowedIds.includes(item.pageId)) {
              return item.to; // return first matching route
            }
          }
          return null;
        };
        
        const firstAllowedPage = findFirstAllowedPage(sidebarItems, permissions);
          history(firstAllowedPage)
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          transition: Flip,
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.SET_LOGIN,
          loader: false,
        });
      });
  };
};

//forget password

export const ForgetPassword = (Data) => {
  
  return async (dispatch) => {
    await axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/forgetpass`, Data, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        dispatch({
          type: actionTypes.FORGET_PASSWORD,
          forgetpassword: response?.data,
          loader: false
        })
        toast.success(response?.data?.message, {
          transition: Flip,
          theme: "colored",
          autoClose: 2000,
        });
      })

      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          transition: Flip,
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.LOADER,
          loader: false,
        });
      });
  };
};

// for change password
export const ChangePasswords = (Data) => {
  return async (dispatch) => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("_id");
    const logintype = urlParams.get("logintype");
    await axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/changepass?_id=${id}&logintype=${logintype}`,
        Data,
        {
          headers: {
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        dispatch({
          type: actionTypes.CHANGE_PASSWORD,
          changepassword: response.data,
          loader: false,
        });
        toast.success(response?.data?.message, {
          transition: Flip,
          theme: "colored",
          autoClose: 2000,
        });

      })

      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          transition: Flip,
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.LOADER,
          loader: false,
        });
      });
  };
};

// for rest password for hr 

export const ResetPassword = (Data, history) => {

  return async (dispatch) => {
    const userData = localStorage.getItem("Admin");
    const logintype = JSON.parse(userData)?.data?.role;
    // Set a default URL
    let apiURL = `${process.env.REACT_APP_API_BASE_URL}/resetpassword`;

    if (logintype === "Corporate") {
      const _id = JSON.parse(userData)?.data?.corporateID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    } else if (logintype === "Hr") {
      const _id = JSON.parse(userData)?.data?.hrID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    } else if (logintype === "Doctor") {
      const _id = JSON.parse(userData)?.data?.hrID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    } else if (logintype === "Branch-Hr") {
      const _id = JSON.parse(userData)?.data?.hrID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    } else if (logintype === "Corporate-branch") {
      const _id = JSON.parse(userData)?.data?.corporateID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    } else if (logintype === "Vfs-Master") {
      const _id = JSON.parse(userData)?.data?.corporateID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    } else if (logintype === "Vfs-Branch") {
      const _id = JSON.parse(userData)?.data?.corporateID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    } else if (logintype === "Master-Corporate") {
      const _id = JSON.parse(userData)?.data?.corporateID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    } else if (logintype === "vfsuklk") {
      const _id = JSON.parse(userData)?.data?.corporateID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    }else if (logintype === "vsf_onevasco") {
      const _id = JSON.parse(userData)?.data?.corporateID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    }else if (logintype === "accountant" || logintype === "sales" || logintype === "support") {
      const _id = JSON.parse(userData)?.data?.hrID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    }else if (logintype === "Admin") {
      const _id = JSON.parse(userData)?.data?._id;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    }else if (logintype === "admanager" || logintype === "adsales" || logintype === "adsupport" || logintype === "adaccountant") {
      const _id = JSON.parse(userData)?.data?.hrID;
      apiURL = `${apiURL}?_id=${_id}&logintype=${logintype}`;
    }

    try {
      const response = await axios.patch(
        apiURL,
        Data,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      dispatch({
        type: actionTypes.RESET_PASSWORD,
        resetpassword: response.data,
        loader: false,
      });
      if (response.data.code === 200) {
        await Swal.fire({
          title: "Your password has been updated successfully.",
          icon: "success",
          iconColor: "#FCDD00",
          confirmButtonText: "Login",
          confirmButtonColor: "#FCDD00",
          customClass: {
            confirmButton: "custom-confirm-button",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              if(logintype === 'vfsuklk'){
                history("/vfs_uk_lp/login");
              }else if(logintype === 'accountant' || logintype === 'sales' || logintype === 'support'){
                history("/vfs_uk_lp/team/login");
              }else if(logintype === 'vsf_onevasco'){
                history("/onevasco/login");
              }else{
                history("/login");
              }
            }, 0);
          }
        });
      }

    } catch (err) {
      console.log(err,"changes password error");
      
      toast.error(err?.response?.data?.error, {
        transition: Flip,
        theme: "colored",
        autoClose: 2000,
      });

      dispatch({
        type: actionTypes.LOADER,
        loader: false,
      });
    }
  };
};


// ResetPassword for admanager, adsales, adaccountant, adsupport
export const ResetPasswordForAd = (Data, history) => {
  return async (dispatch) => {
    const userData = localStorage.getItem("Admin");
    const token = JSON.parse(userData);
    const userToken = token?.data?.token;
    let apiURL = `${process.env.REACT_APP_API_BASE_URL}/admin/team/change-password`;
    try {
      const response = await axios.patch(
        apiURL,
        Data,
        {
          headers: {
            Accept: "application/json",
            "x-access-token": userToken

          },
        }
      );
      dispatch({
        type: actionTypes.RESET_PASSWORD,
        resetpassword: response.data,
        loader: false,
      });
      if (response.data.code === 200) {
        await Swal.fire({
          title: "Your password has been updated successfully.",
          icon: "success",
          iconColor: "#FCDD00",
          confirmButtonText: "Login",
          confirmButtonColor: "#FCDD00",
          customClass: {
            confirmButton: "custom-confirm-button",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
                history("/admin/admin_team/login");
            }, 0);
          }
        });
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        transition: Flip,
        theme: "colored",
        autoClose: 2000,
      });
      dispatch({
        type: actionTypes.LOADER,
        loader: false,
      });
    }
  };
}

// change password for employee 
export const EmpChangePasswords = (Data, id) => {
  return async (dispatch) => {
    await axios
      .patch(
        `${process.env.REACT_APP_API_BASE_URL}/employee/changepassword/${id}`,
        Data,
        {
          headers: {
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        dispatch({
          type: actionTypes.CHANGE_PASSWORD,
          changepassword: response.data,
          loader: false,
        });
        if (response.data.code === 200) {
          Swal.fire({
            title: "The password has been changed successfully. Please log in to the mobile app using your new password.",
            icon: "success",
            iconColor: "#FCDD00",
            confirmButtonText: "Ok",
            confirmButtonColor: "#FCDD00",
            customClass: {
              confirmButton: "custom-confirm-button",
            },
          })
        }
      })

      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          transition: Flip,
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.LOADER,
          loader: false,
        });
      });
  };
};

// get payment details
export const getPaymentDetails = (id) => {
  return async (dispatch) => {
    await axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/transaction/${id}`, {},
        {
          headers: {
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        dispatch({
          type: actionTypes.GET_PAYMENT_DETAIL,
          paymentDetail: response.data,
          loader: false,
        });

      })

      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          transition: Flip,
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.LOADER,
          loader: false,
        });
      });
  };
};

// download invoice

export const downloadInvoice = (id) => {
  return async (dispatch) => {
    await axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/download/transaction/${id}`,
        { responseType: 'arraybuffer' }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Invoice.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success("PDF exported successfully.", {
          theme: "colored",
          autoClose: 2000,
        });

        dispatch({
          type: actionTypes.LOADER,
          loader: false,
        });
      })
      .catch((err) => {
        toast.error("PDF export failed or no record found.", {
          theme: "colored",
          autoClose: 2000,
        });

        dispatch({
          type: actionTypes.LOADER,
          loader: false,
        });
      });
  };
};





